import Image from 'next/image';

export function ItemIcon({ src, isLarge }: { isLarge?: boolean; src: string }) {
  const size = isLarge ? 30 : 20;

  return <Image alt='nav-img' width={size} height={size} src={src} />;
}
